/*
 * Totter + Tumble – Back in stock form: "Don't want to wait?" nearest match
 *
 * Replaces the recommendations logic in klavyio-notify.js (loadRecs) so the
 * thank-you screen always tries to suggest the closest matching playmats that
 * are in stock in the size the customer registered for.
 *
 * How it picks:
 *  1. Works out the size signed up for. Single-size products (e.g. XL-only
 *     designs) use their one size – the old logic skipped these entirely.
 *  2. Loads every playmat from /collections/all via sections/nm-recs.liquid
 *     (best-selling first).
 *  3. Keeps only designs with that size in stock, skips the current product
 *     and the other side of the same reversible mat (YGroup_ tag).
 *  4. Scores each one against the product being viewed:
 *       same colour collection       +100
 *       each other shared collection  +20  (e.g. Morris & Co., a theme collection)
 *       each shared tag               +3
 *     Highest score wins; ties go to the better seller.
 *  5. If nothing qualifies, falls back to Shopify's related products.
 *
 * Loaded from snippets/product-buttons.liquid. If this file fails to load, the
 * original logic in klavyio-notify.js still runs.
 */
(function () {
  var SOURCE = '/collections/all';
  var MAX_PAGES = 4; // 50 products per page
  var COUNT = 3;
  var COLOUR = ['the-greys-the-neutrals', 'the-greens-the-blues', 'the-pinks-oranges-and-yellows', 'the-dark-tones'];
  var SCORE = { colour: 100, collection: 20, tag: 3 };
  var TEXT = {
    subColour: function (size, colour) { return 'These ' + size + ' designs in ' + colour + ' are in stock now – you may love them too.'; },
    sub: function (size) { return 'These ' + size + ' designs are in stock now – you may love them too.'; }
  };

  function sizeLabel(title) {
    return String(title || '').split(' Size')[0].split('|')[0].replace(/^Play\s+/i, '').trim();
  }

  function groupOf(tags) {
    return (tags || []).filter(function (t) { return String(t).indexOf('YGroup_') === 0; })[0] || '';
  }

  function fetchPage(page) {
    return fetch(SOURCE + '?sort_by=best-selling&sections=nm-recs&page=' + page)
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var holder = document.createElement('div');
        holder.innerHTML = json['nm-recs'] || '';
        var script = holder.querySelector('[data-nm-recs-json]');
        if (!script) return { pages: 0, items: [] };
        var data = JSON.parse(script.textContent);
        if (Array.isArray(data)) return { pages: 1, items: data.filter(Boolean) };
        return { pages: data.pages || 1, items: (data.items || []).filter(Boolean) };
      });
  }

  function fetchAll() {
    return fetchPage(1).then(function (first) {
      var last = Math.min(first.pages || 1, MAX_PAGES);
      var rest = [];
      for (var p = 2; p <= last; p++) {
        rest.push(fetchPage(p).catch(function () { return { items: [] }; }));
      }
      return Promise.all(rest).then(function (pages) {
        return pages.reduce(function (all, page) { return all.concat(page.items); }, first.items);
      });
    });
  }

  function patch(Cls) {
    var proto = Cls && Cls.prototype;
    if (!proto || proto.__nmNearest) return;
    proto.__nmNearest = true;

    // Size name for the variant signed up for. Multi-size products already know it
    // from the size picker; single-size products look it up from the product.
    proto.nmSizeFor = function (variantId) {
      var known = this.sizeNames && this.sizeNames[variantId];
      if (known) return Promise.resolve(known);
      var handle = this.dataset.productHandle;
      if (!handle) return Promise.resolve('');
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var variants = product.variants || [];
          var v = variants.filter(function (x) { return String(x.id) === String(variantId); })[0] || variants[0];
          if (!v || /^default title$/i.test(v.title)) return '';
          return sizeLabel(v.title);
        })
        .catch(function () { return ''; });
    };

    proto.loadRecs = function (variantIds) {
      var self = this;
      var box = this.querySelector('[data-nm-recs]');
      if (!box || !variantIds || !variantIds.length) return;

      this.nmSizeFor(variantIds[0]).then(function (sizeName) {
        if (!sizeName) return;

        fetchAll()
          .catch(function () { return []; })
          .then(function (list) {
            var picks = self.pickNearest(list, sizeName);
            if (picks.length) return picks;
            return fetch('/recommendations/products.json?product_id=' + self.dataset.productId + '&limit=10&intent=related')
              .then(function (r) { return r.json(); })
              .then(function (json) { return self.pickNearest((json.products || []).map(self.normaliseRec), sizeName); })
              .catch(function () { return []; });
          })
          .then(function (picks) {
            if (!picks.length) return;
            var colour = self.dataset.colourCollection;
            var colourTitle = self.dataset.colourTitle;
            var allSameColour = colour && colourTitle && picks.every(function (pick) {
              return (pick.product.collections || []).indexOf(colour) > -1;
            });
            box.querySelector('[data-nm-recs-sub]').textContent = allSameColour
              ? TEXT.subColour(sizeName, colourTitle)
              : TEXT.sub(sizeName);
            var grid = box.querySelector('[data-nm-recs-grid]');
            grid.innerHTML = '';
            picks.forEach(function (pick) { grid.appendChild(self.recCard(pick)); });
            box.hidden = false;
          });
      });
    };

    proto.pickNearest = function (list, sizeName) {
      var handle = this.dataset.productHandle;
      var me = list.filter(function (p) { return p && p.handle === handle; })[0];
      var myCols = ((me && me.collections) || []).filter(Boolean);
      var colour = this.dataset.colourCollection;
      if (colour && myCols.indexOf(colour) === -1) myCols.push(colour);
      var myTags = ((me && me.tags) || []).filter(function (t) { return String(t).indexOf('YGroup_') !== 0; });
      var myGroup = this.dataset.groupTag || groupOf(me && me.tags);

      var scored = [];
      list.forEach(function (p, index) {
        if (!p || p.handle === handle) return;
        var group = groupOf(p.tags);
        if (myGroup && group === myGroup) return; // other side of this mat
        var variant = (p.variants || []).filter(function (v) { return v.available && sizeLabel(v.title) === sizeName; })[0];
        if (!variant) return;
        var score = 0;
        (p.collections || []).forEach(function (c) {
          if (c && myCols.indexOf(c) > -1) score += COLOUR.indexOf(c) > -1 ? SCORE.colour : SCORE.collection;
        });
        (p.tags || []).forEach(function (t) {
          if (myTags.indexOf(t) > -1) score += SCORE.tag;
        });
        scored.push({ product: p, variant: variant, score: score, index: index, group: group });
      });

      scored.sort(function (a, b) { return (b.score - a.score) || (a.index - b.index); });

      var seenGroups = {};
      var picks = [];
      for (var i = 0; i < scored.length && picks.length < COUNT; i++) {
        var s = scored[i];
        if (s.group) {
          if (seenGroups[s.group]) continue; // don't show both sides of one mat
          seenGroups[s.group] = true;
        }
        picks.push({ product: s.product, variant: s.variant });
      }
      return picks;
    };
  }

  if (window.customElements) {
    customElements.whenDefined('notify-me-klavio').then(function () {
      patch(customElements.get('notify-me-klavio'));
    });
  }
})();
